(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4696],{

/***/ 68049:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/servers/cloud-servers",
      function () {
        return __webpack_require__(77098);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 14313:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(59072);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11527);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50959);
/* harmony import */ var _SSSAccordion__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2097);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66264);





function SSS(param) {
    var data = param.data;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)([
        "common",
        "nav"
    ]).t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: "container px-4 mx-auto bg-white lg:px-0",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "my-5 lg:my-10",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "relative z-30 text-4xl font-semibold text-after-shadow lg:text-5xl",
                    children: t("frequentlyAskedQuestions")
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "grid grid-cols-2 mt-10 lg:gap-x-8",
                    children: data && Object.entries(data).map(function(param) {
                        var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(param, 2), key = _param[0], value = _param[1];
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SSSAccordion__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            title: key,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                dangerouslySetInnerHTML: {
                                    __html: value
                                }
                            })
                        }, key);
                    })
                })
            ]
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (SSS);


/***/ }),

/***/ 2097:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11527);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50959);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2218);



function SSSAccordion(param) {
    var title = param.title, children = param.children;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), open = ref[0], setOpen = ref[1];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "faqAccordionColspan",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "w-full p-3 border-2 ".concat(open ? "rounded-b-none border-b" : "rounded-md"),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    onClick: function() {
                        return setOpen(!open);
                    },
                    className: "faqTitleStyle",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "font-semibold text-md",
                            children: title
                        }),
                        !open ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                            className: "text-xl font-semibold ri-add-line"
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                            className: "text-xl font-semibold ri-subtract-line"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "faqChildrenStyle ".concat(open ? "block" : "hidden", " "),
                children: children
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (SSSAccordion);


/***/ }),

/***/ 77098:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ cloud_servers; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(59072);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(11527);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.4_react-dom@18.2.0_react@18.2.0/node_modules/next/head.js
var head = __webpack_require__(93834);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./layout/Layout/index.js + 9 modules
var Layout = __webpack_require__(4967);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.4_react-dom@18.2.0_react@18.2.0/node_modules/next/image.js
var next_image = __webpack_require__(70649);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./components/SSS/SSS.js
var SSS = __webpack_require__(14313);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-loader-spinner@4.0.0_react-dom@18.2.0_react@18.2.0/node_modules/react-loader-spinner/dist/index.js
var dist = __webpack_require__(56538);
// EXTERNAL MODULE: ./store/GlobalStore.js
var GlobalStore = __webpack_require__(36345);
// EXTERNAL MODULE: ./node_modules/.pnpm/next-i18next@13.0.2_i18next@22.4.6_next@12.3.4_react-i18next@12.1.1_react@18.2.0/node_modules/next-i18next/dist/esm/index.js + 11 modules
var esm = __webpack_require__(66264);
// EXTERNAL MODULE: ./helpers/helpersFunc.js + 2 modules
var helpersFunc = __webpack_require__(65126);
// EXTERNAL MODULE: ./components/FormElements/Button.js
var Button = __webpack_require__(62303);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.4_react-dom@18.2.0_react@18.2.0/node_modules/next/link.js
var next_link = __webpack_require__(13786);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./store/ConfigurationStore.js
var ConfigurationStore = __webpack_require__(20363);
;// CONCATENATED MODULE: ./public/SSS/sss-tr-bulut-sunucu.json
var sss_tr_bulut_sunucu_namespaceObject = JSON.parse('{"Cloud Server Kiralama Süreci Nasıl İşler?":"İhtiyacınıza uygun bir paket seçersiniz. CPU, RAM, depolama ve bant genişliği gibi kaynakları belirleyebilirsiniz. İşletim sisteminizi (Windows/Linux) seçtikten sonra, sunucu dakikalar içinde kullanıma hazır hale gelir.","En Uygun Bulut Sunucu Fiyatları Nasıl Belirlenir?":"Kullandığınız kaynaklara (CPU, RAM, Disk vb.) göre fiyatlandırma yapılır. Paylaşımlı veya özel kaynak kullanımına göre fiyat değişiklik gösterebilir. Makdos, esnek fiyatlandırma seçenekleri sunarak bütçenize uygun çözümler sağlar.","Verilerim Nasıl Korunuyor?":"Güvenlik duvarları (firewall) ve DDoS koruma sistemleri kullanılır. Otomatik yedekleme seçenekleri sayesinde verileriniz düzenli olarak saklanır. SSL şifreleme, izinsiz erişimleri engellemek için kullanılır.","Hangi İşletim Sistemleri Destekleniyor?":"Windows Server (2016, 2019, 2022). Linux Dağıtımları (Ubuntu, CentOS, Debian, AlmaLinux, Rocky Linux vb.). Özel talepler için farklı işletim sistemleri kurulabilir.","Cloud Server Performansı Nasıl Ölçülür?":"Sunucunun işlemci (CPU) ve RAM kullanım durumu kontrol edilir. Disk okuma/yazma hızları ve internet bağlantı performansı test edilir. Makdos, yüksek hızlı SSD diskler ve optimize edilmiş sunucu yapılandırmaları sunar.","Cloud Server İçin Hangi Kullanım Alanları Uygundur?":"E-ticaret siteleri. Kurumsal web siteleri ve içerik platformları. Oyun sunucuları (Minecraft, CS:GO vb.). Yazılım geliştirme ve test ortamları. Veri tabanı barındırma.","Cloud Server ile Web Hosting Arasındaki Fark Nedir?":"Web hosting, paylaşımlı kaynaklarla çalışır ve küçük ölçekli projeler için uygundur. <b>Cloud server</b>, özel kaynaklara sahip ve daha büyük ölçekli projeler için optimize edilmiştir. Web hosting, genellikle daha uygun fiyatlıdır ancak ölçeklenebilirlik açısından <b>cloud server</b> daha avantajlıdır.","Cloud Server’ın Uptime Oranı Nedir?":"Makdos’un  <b>bulut sunucu</b> hizmetleri %99.8 uptime garantisi ile çalışmaktadır. Kesintisiz erişim için yüksek yedeklilikli altyapı ve gelişmiş ağ sistemleri kullanılır.","Sunucumu Yükseltmek İstersem Ne Yapmalıyım?":"Panel üzerinden RAM, CPU veya disk kapasitenizi kolayca artırabilirsiniz. Makdos’un esnek ölçeklendirme sistemi sayesinde anlık yükseltme mümkündür.","Cloud Server’da DDoS Koruma Var mı?":"Tüm Makdos <b>cloud server</b> ’lar, güçlü DDoS koruma sistemleriyle korunmaktadır. Saldırılara karşı özel güvenlik duvarları ve trafik filtreleme sistemleri kullanılır.","Sunucuma Uzaktan Erişebilir miyim?":"Evet. SSH (Linux) veya RDP (Windows) ile uzaktan bağlantı yapabilirsiniz. İnternet bağlantısı olan her yerden erişim mümkündür.","Cloud Server İçin Yedekleme Hizmeti Sunuluyor mu?":"Müşteri talebine bağlı olarak günlük, haftalık veya aylık yedekleme seçenekleri sunulmaktadır. Yedekleme hizmeti sayesinde veri kaybına karşı güvence sağlanır.","Ekstra IP Adresi Alabilir miyim?":"Evet. İhtiyacınıza göre ek IP adresleri talep edebilirsiniz.","Cloud Server\'da Hangi Veri Merkezleri Kullanılıyor?":"Makdos, güvenilir ve yüksek hızda çalışan veri merkezleriyle hizmet vermektedir. Veri merkezleri, Tier III+ seviyesinde altyapıya sahiptir.","Cloud Server’ı Kaç Kişi Kullanabilir?":"İhtiyacınıza bağlı olarak tek kullanıcılı veya çok kullanıcılı erişim sağlanabilir. Kullanıcı erişim yönetimi ve yetkilendirme desteği sunulmaktadır.","Sunucuma Ek Güvenlik Önlemleri Ekleyebilir miyim?":"Evet. Firewall ayarlarını özelleştirebilir, ek güvenlik yazılımları yükleyebilirsiniz. Makdos’un sunduğu güvenlik çözümleri ile ek koruma sağlayabilirsiniz.","Cloud Server İçin Bant Genişliği Nasıl Belirlenir?":"Standart paketler belirli bir bant genişliği ile gelir. Ek trafik ihtiyacınız varsa, özel bant genişliği seçeneklerinden yararlanabilirsiniz.","Cloud Server’da Özel Yazılım Çalıştırabilir miyim?":"Evet. Sunucunuza ihtiyacınıza uygun özel yazılımlar kurabilirsiniz.","Makdos Cloud Server Hizmetleri İçin Teknik Destek Var mı?":"Evet! Makdos, 7/24 teknik destek sunmaktadır. Herhangi bir sorun yaşadığınızda uzman ekibimiz size yardımcı olacaktır.","Hizmetinizi denemek istiyorum, ücretsiz deneme süresi sunuyor musunuz?":"Maalesef ücretsiz deneme hizmetimiz bulunmamaktadır.","Hangi ödeme yöntemlerini kabul ediyorsunuz?":"Makdos Bilişim, kredi kartı, banka havalesi ve PayPal gibi popüler ödeme yöntemlerini kabul etmektedir.","Sunucularınız nerede bulunuyor?":"Sunucularımız Türkiye ve Avrupa (Yakında) ve Amerika\'daki (Yakında) çeşitli veri merkezlerinde bulunmaktadır."}');
;// CONCATENATED MODULE: ./public/SSS/sss-en-bulut-sunucu.json
var sss_en_bulut_sunucu_namespaceObject = JSON.parse('{"How does Cloud Server Rental process work?":"You choose a package that suits your needs. You can specify resources such as CPU, RAM, storage and bandwidth. After choosing your operating system (Windows/Linux), the server is ready for use within minutes.","How to determine the best Cloud Server Prices?":"Pricing is based on the resources you use (CPU, RAM, Disk, etc.). The price may vary according to shared or private resource usage. Makdos provides solutions suitable for your budget by offering flexible pricing options.","How is my data protected?":"Firewalls and DDoS protection systems are used. Your data is stored regularly with automatic backup options. SSL encryption is used to prevent unauthorized access.","Which operating systems are supported?":"Windows Server (2016, 2019, 2022). Linux Distributions (Ubuntu, CentOS, Debian, AlmaLinux, Rocky Linux, etc.). Different operating systems can be installed for special requests.","How to measure Cloud Server performance?":"CPU and RAM utilization status of the server is checked. Disk read/write speeds and internet connection performance are tested. Makdos offers high-speed SSD disks and optimized server configurations.","Which areas of use are suitable for Cloud Server?":"E-commerce sites. Corporate websites and content platforms. Game servers (Minecraft, CS:GO, etc.). Software development and test environments. Database hosting.","What is the difference between Cloud Server and Web Hosting?":"Web hosting works with shared resources and is suitable for small-scale projects. <b>Cloud server</b> has dedicated resources and is optimized for larger-scale projects. Web hosting is usually more affordable, but <b>cloud server</b> is more advantageous in terms of scalability.","What is the Uptime Rate of Cloud Server?":"Makdos\' <b>cloud server</b> services work with 99.8% uptime guarantee. High redundancy infrastructure and advanced network systems are used for uninterrupted access.","What should I do if I want to upgrade my server?":"You can easily increase your RAM, CPU or disk capacity through the panel. Instant upgrade is possible with Makdos\' flexible scaling system.","Is there DDoS protection on Cloud Server?":"All Makdos <b>cloud server</b>s are protected by powerful DDoS protection systems. Special firewalls and traffic filtering systems are used against attacks.","Can I access my server remotely?":"Yes, you can. You can connect remotely via SSH (Linux) or RDP (Windows). Access is possible from anywhere with an internet connection.","Is backup service offered for Cloud Server?":"Daily, weekly or monthly backup options are offered depending on customer demand. Backup service provides assurance against data loss.","Can I get extra IP addresses?":"Yes, you can. You can request additional IP addresses according to your needs.","Which data centers are used in Cloud Server?":"Makdos provides services with reliable and high-speed data centers. Data centers have Tier III+ level infrastructure.","How many people can use Cloud Server?":"Single-user or multi-user access can be provided depending on your needs. User access management and authorization support is provided.","Can I add additional security measures to my server?":"Yes, you can. You can customize firewall settings and install additional security software. You can provide additional protection with the security solutions offered by Makdos.","How to determine bandwidth for Cloud Server?":"Standard packages come with a certain bandwidth. If you need additional traffic, you can take advantage of special bandwidth options.","Can I run custom software on Cloud Server?":"Yes, you can. You can install custom software on your server according to your needs.","Is there technical support for Makdos Cloud Server Services?":"Yes! Makdos offers 24/7 technical support. Our expert team will help you if you have any problems.","I want to try your service, do you offer a free trial period?":"Unfortunately, we do not offer a free trial.","Which payment methods do you accept?":"Makdos Bilisim accepts popular payment methods such as credit card, bank transfer and PayPal.","Where are your servers located?":"Our servers are located in various data centers in Turkey and Europe (coming soon) and America (coming soon)."}');
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.4_react-dom@18.2.0_react@18.2.0/node_modules/next/router.js
var next_router = __webpack_require__(63498);
// EXTERNAL MODULE: ./helpers/googleEvents.js
var googleEvents = __webpack_require__(41804);
;// CONCATENATED MODULE: ./components/CloudServers/WhatIsCloudServer.js



var WhatIsCloudServer = function() {
    var t = (0,esm/* useTranslation */.$G)([
        "common",
        "cloudServer"
    ]).t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "pt-16 bg-buttonBg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "container mx-auto",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: "relative z-10 text-3xl font-bold text-center lg:text-4xl text-titleColor text-after-shadow-cloud",
                    children: t("cloudServer:whatIsCloudServer")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "pt-8 text-center text-textGray",
                    dangerouslySetInnerHTML: {
                        __html: t("cloudServer:whatIsCloudServerDesc")
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex items-center justify-center pt-16",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: "/whatIsCloudServer.png",
                        width: 797,
                        height: 537,
                        alt: t("cloudServer:whatIsCloudServer"),
                        title: t("cloudServer:whatIsCloudServer")
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var CloudServers_WhatIsCloudServer = (WhatIsCloudServer);

;// CONCATENATED MODULE: ./components/CloudServers/CloudServersAdvantages.js



var CloudServersAdvantages = function() {
    var t = (0,esm/* useTranslation */.$G)([
        "common",
        "cloudServer"
    ]).t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "container py-12 mx-auto lg:py-24",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: "relative z-10 text-3xl font-bold text-center lg:text-4xl text-titleColor text-after-shadow-cloud2",
                children: t("cloudServer:cloudServersAdvantages")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "grid items-center px-4 pt-12 lg:grid-cols-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: "/flexibilityAndScalability.png",
                            width: 407,
                            height: 380,
                            alt: t("cloudServer:cloudServersAdvantages"),
                            title: t("cloudServer:cloudServersAdvantages")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "my-4 text-2xl font-bold text-titleColor lg:text-3xl",
                                children: t("cloudServer:flexibilityAndScalability")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: " text-textGray",
                                dangerouslySetInnerHTML: {
                                    __html: t("cloudServer:flexibilityAndScalabilityDesc")
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex py-4 space-x-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: "p-2 w-[24px] h-[24px] flex items-center justify-center text-white bg-green-500 rounded-full ri-check-line"
                                    }),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-textGray",
                                        children: t("cloudServer:flexibilityAndScalabilityDesc2")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex py-4 space-x-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: "p-2 w-[24px] h-[24px] flex items-center justify-center text-white bg-green-500 rounded-full ri-check-line"
                                    }),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-textGray",
                                        children: t("cloudServer:flexibilityAndScalabilityDesc3")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex py-4 space-x-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: "p-2 w-[24px] h-[24px] flex items-center justify-center text-white bg-green-500 rounded-full ri-check-line"
                                    }),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-textGray",
                                        children: t("cloudServer:flexibilityAndScalabilityDesc4")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "pt-4 text-textGray",
                                dangerouslySetInnerHTML: {
                                    __html: t("cloudServer:flexibilityAndScalabilityDesc5")
                                }
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "grid items-center px-4 pt-12 lg:grid-cols-2 gap-x-80",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "my-4 text-2xl font-bold text-titleColor lg:text-3xl",
                                children: t("cloudServer:lowerCoast")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: " text-textGray",
                                dangerouslySetInnerHTML: {
                                    __html: t("cloudServer:lowerCoastDesc")
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex py-4 space-x-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: "p-2 w-[24px] h-[24px] flex items-center justify-center text-white bg-green-500 rounded-full ri-check-line"
                                    }),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-textGray",
                                        children: t("cloudServer:lowerCoastDesc2")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex py-4 space-x-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: "p-2 w-[24px] h-[24px] flex items-center justify-center text-white bg-green-500 rounded-full ri-check-line"
                                    }),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-textGray",
                                        children: t("cloudServer:lowerCoastDesc3")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex py-4 space-x-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: "p-2 w-[24px] h-[24px] flex items-center justify-center text-white bg-green-500 rounded-full ri-check-line"
                                    }),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-textGray",
                                        children: t("cloudServer:lowerCoastDesc4")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "pt-4 text-textGray",
                                children: t("cloudServer:lowerCoastDesc5")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: "/lowerCost.png",
                            width: 434,
                            height: 406,
                            alt: t("cloudServer:lowerCoast"),
                            title: t("cloudServer:lowerCoast")
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "grid items-center px-4 pt-12 lg:grid-cols-2 gap-x-80 ",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "order-2 lg:order-1",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: "/highAvailability.png",
                            width: 434,
                            height: 406,
                            alt: t("cloudServer:highAvailabilityAndSecurity"),
                            title: t("cloudServer:highAvailabilityAndSecurity")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "order-1 lg:order-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "my-4 text-2xl font-bold text-titleColor lg:text-3xl",
                                children: t("cloudServer:highAvailabilityAndSecurity")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: " text-textGray",
                                dangerouslySetInnerHTML: {
                                    __html: t("cloudServer:highAvailabilityAndSecurityDesc")
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex py-4 space-x-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: "p-2 w-[24px] h-[24px] flex items-center justify-center text-white bg-green-500 rounded-full ri-check-line"
                                    }),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-textGray",
                                        children: t("cloudServer:highAvailabilityAndSecurityDesc2")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex py-4 space-x-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: "p-2 w-[24px] h-[24px] flex items-center justify-center text-white bg-green-500 rounded-full ri-check-line"
                                    }),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-textGray",
                                        children: t("cloudServer:highAvailabilityAndSecurityDesc3")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex py-4 space-x-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: "p-2 w-[24px] h-[24px] flex items-center justify-center text-white bg-green-500 rounded-full ri-check-line"
                                    }),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-textGray",
                                        children: t("cloudServer:highAvailabilityAndSecurityDesc4")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "pt-4 text-textGray",
                                children: t("cloudServer:highAvailabilityAndSecurityDesc5")
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "grid items-center px-4 pt-12 lg:grid-cols-2 gap-x-80",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "my-4 text-2xl font-bold text-titleColor lg:text-3xl",
                                children: t("cloudServer:remoteAccess")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: " text-textGray",
                                dangerouslySetInnerHTML: {
                                    __html: t("cloudServer:remoteAccessDesc")
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex py-4 space-x-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: "p-2 w-[24px] h-[24px] flex items-center justify-center text-white bg-green-500 rounded-full ri-check-line"
                                    }),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-textGray",
                                        children: t("cloudServer:remoteAccessDesc2")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex py-4 space-x-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: "p-2 w-[24px] h-[24px] flex items-center justify-center text-white bg-green-500 rounded-full ri-check-line"
                                    }),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "text-textGray",
                                        dangerouslySetInnerHTML: {
                                            __html: t("cloudServer:remoteAccessDesc3")
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex py-4 space-x-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: "p-2 w-[24px] h-[24px] flex items-center justify-center text-white bg-green-500 rounded-full ri-check-line"
                                    }),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-textGray",
                                        children: t("cloudServer:remoteAccessDesc4")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "pt-4 text-textGray",
                                dangerouslySetInnerHTML: {
                                    __html: t("cloudServer:remoteAccessDesc5")
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: "/remoteAccess.png",
                            width: 420,
                            height: 405,
                            alt: t("cloudServer:remoteAccess"),
                            title: t("cloudServer:remoteAccess")
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "grid items-center px-4 pt-12 lg:grid-cols-2 gap-x-80",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "order-2 lg:order-1",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: "/highPerformanceAndSpeed.png",
                            width: 420,
                            height: 405,
                            alt: t("cloudServer:highPerformanceAndSpeed"),
                            title: t("cloudServer:highPerformanceAndSpeed")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "order-1 lg:order-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "my-4 text-2xl font-bold text-titleColor lg:text-3xl",
                                children: t("cloudServer:highPerformanceAndSpeed")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: " text-textGray",
                                dangerouslySetInnerHTML: {
                                    __html: t("cloudServer:highPerformanceAndSpeedDesc")
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex py-4 space-x-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: "p-2 w-[24px] h-[24px] flex items-center justify-center text-white bg-green-500 rounded-full ri-check-line"
                                    }),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-textGray",
                                        children: t("cloudServer:highPerformanceAndSpeedDesc2")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex py-4 space-x-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: "p-2 w-[24px] h-[24px] flex items-center justify-center text-white bg-green-500 rounded-full ri-check-line"
                                    }),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-textGray",
                                        children: t("cloudServer:highPerformanceAndSpeedDesc3")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex py-4 space-x-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: "p-2 w-[24px] h-[24px] flex items-center justify-center text-white bg-green-500 rounded-full ri-check-line"
                                    }),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-textGray",
                                        children: t("cloudServer:highPerformanceAndSpeedDesc4")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "pt-4 text-textGray",
                                children: t("cloudServer:highPerformanceAndSpeedDesc5")
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var CloudServers_CloudServersAdvantages = (CloudServersAdvantages);

;// CONCATENATED MODULE: ./components/CloudServers/CloudRentalInstallationProcess.js



var CloudRentalInstallationProcess = function() {
    var t = (0,esm/* useTranslation */.$G)([
        "common",
        "cloudServer"
    ]).t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "py-8 lg:py-16 bg-buttonBg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "container mx-auto",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: "mb-4 text-3xl font-bold text-center lg:text-4xl text-titleColor",
                    children: t("cloudServer:cloudRentalInstallationProcess")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "text-center text-textGray",
                    dangerouslySetInnerHTML: {
                        __html: t("cloudServer:cloudRentalInstallationProcessDesc")
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "grid px-4 pt-12 lg:grid-cols-2",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: "/rentalCloudServer.png",
                                width: 520,
                                height: 491,
                                alt: t("cloudServer:cloudRentalInstallationProcess"),
                                title: t("cloudServer:cloudRentalInstallationProcess")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "lg:h-[584px] overflow-y-auto scrollbar-custom lg:pr-10 space-y-8",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    className: "font-semibold text-titleColor",
                                    children: t("cloudServer:cloudRentalInstallationProcessDesc8")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-textGray",
                                    dangerouslySetInnerHTML: {
                                        __html: t("cloudServer:cloudRentalInstallationProcessDesc2")
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    className: "text-textGray",
                                    children: [
                                        "\uD83D\uDD39",
                                        t("cloudServer:cloudRentalInstallationProcessDesc3")
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    className: "text-textGray",
                                    children: [
                                        "\uD83D\uDD39",
                                        t("cloudServer:cloudRentalInstallationProcessDesc4")
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    className: "text-textGray",
                                    children: [
                                        "\uD83D\uDD39",
                                        t("cloudServer:cloudRentalInstallationProcessDesc5")
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-textGray",
                                    dangerouslySetInnerHTML: {
                                        __html: t("cloudServer:cloudRentalInstallationProcessDesc6")
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-textGray",
                                    children: t("cloudServer:cloudRentalInstallationProcessDesc7")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    className: "font-semibold text-titleColor",
                                    children: t("cloudServer:userFriendlyAdministrationPanel")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-textGray",
                                    dangerouslySetInnerHTML: {
                                        __html: t("cloudServer:userFriendlyAdministrationPanelDesc")
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    className: "text-textGray",
                                    children: [
                                        "\uD83D\uDCCC ",
                                        t("cloudServer:userFriendlyAdministrationPanelDesc2")
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    className: "text-textGray",
                                    children: [
                                        "\uD83D\uDCCC ",
                                        t("cloudServer:userFriendlyAdministrationPanelDesc3")
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    className: "text-textGray",
                                    children: [
                                        "\uD83D\uDCCC ",
                                        t("cloudServer:userFriendlyAdministrationPanelDesc4")
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    className: "text-textGray",
                                    children: [
                                        "\uD83D\uDCCC ",
                                        t("cloudServer:userFriendlyAdministrationPanelDesc5")
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-textGray",
                                    dangerouslySetInnerHTML: {
                                        __html: t("cloudServer:userFriendlyAdministrationPanelDesc6")
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    className: "font-semibold text-titleColor",
                                    children: t("cloudServer:configurationOptionsAndAdditionalServices")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-textGray",
                                    dangerouslySetInnerHTML: {
                                        __html: t("cloudServer:configurationOptionsAndAdditionalServicesDesc")
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    className: "text-textGray",
                                    children: [
                                        "✅ ",
                                        t("cloudServer:configurationOptionsAndAdditionalServicesDesc2")
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    className: "text-textGray",
                                    children: [
                                        "✅ ",
                                        t("cloudServer:configurationOptionsAndAdditionalServicesDesc3")
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    className: "text-textGray",
                                    children: [
                                        "✅ ",
                                        t("cloudServer:configurationOptionsAndAdditionalServicesDesc4")
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    className: "text-textGray",
                                    children: [
                                        "✅ ",
                                        t("cloudServer:configurationOptionsAndAdditionalServicesDesc5")
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    className: "text-textGray",
                                    children: [
                                        "✅ ",
                                        t("cloudServer:configurationOptionsAndAdditionalServicesDesc6")
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    className: "text-textGray",
                                    children: [
                                        "✅ ",
                                        t("cloudServer:configurationOptionsAndAdditionalServicesDesc7")
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-textGray",
                                    dangerouslySetInnerHTML: {
                                        __html: t("cloudServer:configurationOptionsAndAdditionalServicesDesc8")
                                    }
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var CloudServers_CloudRentalInstallationProcess = (CloudRentalInstallationProcess);

;// CONCATENATED MODULE: ./components/CloudServers/ImportanceOfCloudTech.js



var ImportanceOfCloudTech = function() {
    var t = (0,esm/* useTranslation */.$G)([
        "common",
        "cloudServer"
    ]).t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "container py-12 mx-auto lg:py-24",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "grid pt-8 mt-12 mb-12 rounded-2xl lg:pt-4 lg:mb-32 lg:gap-10 lg:p-8 lg:grid-cols-2 lg:mt-24 lg:container lg:mx-auto bg-makdosDarkPurple",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "p-4 px-8 pt-1 space-y-8 lg:p-8",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "space-y-3",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    className: "text-3xl font-semibold text-white lg:text-4xl",
                                    children: t("cloudServer:importanceOfCloudTech")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-sm text-white",
                                    dangerouslySetInnerHTML: {
                                        __html: t("cloudServer:importanceOfCloudTechDesc")
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "space-y-8",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "space-y-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex space-x-2 font-medium text-white",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                className: "p-2 w-[24px] h-[24px] flex items-center justify-center text-white bg-green-500 rounded-full ri-check-line"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                children: [
                                                    " ",
                                                    t("cloudServer:importanceOfCloudTechDesc2")
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex space-x-2 font-medium text-white ",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                className: "p-2 w-[24px] h-[24px] flex items-center justify-center text-white bg-green-500 rounded-full ri-check-line"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                children: [
                                                    " ",
                                                    t("cloudServer:importanceOfCloudTechDesc3")
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex space-x-2 font-medium text-white ",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                className: "p-2 w-[24px] h-[24px] flex items-center justify-center text-white bg-green-500 rounded-full ri-check-line"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                children: [
                                                    " ",
                                                    t("cloudServer:importanceOfCloudTechDesc4")
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex space-x-2 font-medium text-white ",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                className: "p-2 w-[24px] h-[24px] flex items-center justify-center text-white bg-green-500 rounded-full ri-check-line"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                children: [
                                                    " ",
                                                    t("cloudServer:importanceOfCloudTechDesc5")
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex space-x-2 font-medium text-white ",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                className: "p-2 w-[24px] h-[24px] flex items-center justify-center text-white bg-green-500 rounded-full ri-check-line"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                children: [
                                                    " ",
                                                    t("cloudServer:importanceOfCloudTechDesc6")
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "m-8 lg:relative",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "p-4 bg-white border-4 rounded-md -top-32 lg:border-8 lg:absolute lg:-right-16 lg:p-8 border-makdosYellow",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex justify-center mb-8",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: "/whyCloudServer.png",
                                    width: 264,
                                    height: 150,
                                    alt: t("cloudServer:whyWithMakdosCloudRental"),
                                    title: t("cloudServer:whyWithMakdosCloudRental")
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                className: "pb-4 text-3xl font-semibold lg:text-4xl text-titleColor",
                                children: t("cloudServer:whyWithMakdosCloudRental")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "pb-3 space-x-2 flexCenter",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        class: "flex justify-center items-center p-2 w-6 h-6 text-white bg-green-500 rounded-full",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                            className: "ri-check-line"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "lg:text-lg",
                                        dangerouslySetInnerHTML: {
                                            __html: t("cloudServer:whyWithMakdosCloudRentalDesc")
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "pb-3 space-x-2 flexCenter",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        class: "flex justify-center items-center p-2 w-6 h-6 text-white bg-green-500 rounded-full",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                            className: "ri-check-line"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "lg:text-lg",
                                        dangerouslySetInnerHTML: {
                                            __html: t("cloudServer:whyWithMakdosCloudRentalDesc2")
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "pb-3 space-x-2 flexCenter",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        class: "flex justify-center items-center p-2 w-6 h-6 text-white bg-green-500 rounded-full",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                            className: "ri-check-line"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "lg:text-lg",
                                        children: t("cloudServer:whyWithMakdosCloudRentalDesc3")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "pb-3 space-x-2 flexCenter",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        class: "flex justify-center items-center p-2 w-6 h-6 text-white bg-green-500 rounded-full",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                            className: "ri-check-line"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "lg:text-lg",
                                        dangerouslySetInnerHTML: {
                                            __html: t("cloudServer:whyWithMakdosCloudRentalDesc4")
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "space-x-2 ",
                                children: [
                                    "\uD83D\uDE80 ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "lg:text-lg",
                                        dangerouslySetInnerHTML: {
                                            __html: t("cloudServer:whyWithMakdosCloudRentalDesc5")
                                        }
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var CloudServers_ImportanceOfCloudTech = (ImportanceOfCloudTech);

;// CONCATENATED MODULE: ./components/CloudServers/HighEfficiencyBestCloud.js




var HighEfficiencyBestCloud = function() {
    var t = (0,esm/* useTranslation */.$G)([
        "common",
        "cloudServer"
    ]).t;
    var ref = (0,react.useState)("virtual-server"), activeSection = ref[0], setActiveSection = ref[1];
    var contentRef = (0,react.useRef)(null);
    var itemRefs = (0,react.useRef)([]);
    var sections = [
        {
            id: "virtual-server",
            title: t("cloudServer:cloudServerDifferencesCloudStorage"),
            desc: t("cloudServer:cloudServerDifferencesCloudStorageDesc"),
            desc2: t("cloudServer:cloudServerDifferencesCloudStorageDesc2"),
            desc3: t("cloudServer:cloudServerDifferencesCloudStorageDesc3")
        },
        {
            id: "used-for",
            title: t("cloudServer:ssdBasedFastStorage"),
            desc: t("cloudServer:ssdBasedFastStorageDesc"),
            desc2: t("cloudServer:ssdBasedFastStorageDesc2"),
            desc3: t("cloudServer:ssdBasedFastStorageDesc3"),
            desc4: t("cloudServer:ssdBasedFastStorageDesc4")
        },
        {
            id: "advantages",
            title: t("cloudServer:dataBackupAndSecurityMeasures"),
            desc: t("cloudServer:dataBackupAndSecurityMeasuresDesc"),
            desc2: t("cloudServer:dataBackupAndSecurityMeasuresDesc2"),
            desc3: t("cloudServer:dataBackupAndSecurityMeasuresDesc3"),
            desc4: t("cloudServer:dataBackupAndSecurityMeasuresDesc4")
        }
    ];
    var handleClick = function(id) {
        var contentBox = contentRef.current; // Container referansı
        var element = document.getElementById(id); // Hedef eleman
        if (element && contentBox) {
            // Elemanın container'a göre top pozisyonunu hesapla
            var elementTop = element.getBoundingClientRect().top - contentBox.getBoundingClientRect().top;
            // Container'ın mevcut scrollTop değerine elemanın pozisyonunu ekle
            var scrollTopValue = contentBox.scrollTop + elementTop - 7;
            // Container içinde scroll yap
            contentBox.scrollTo({
                top: scrollTopValue,
                behavior: "smooth"
            });
        }
    };
    var handleScroll = function() {
        if (!contentRef.current) return;
        var _current = contentRef.current, scrollTop = _current.scrollTop, scrollHeight = _current.scrollHeight, clientHeight = _current.clientHeight;
        // Scroll pozisyonunu kontrol et
        var contentTop = contentRef.current.getBoundingClientRect().top;
        // Her bir öğenin pozisyonunu kontrol et
        if (scrollTop + clientHeight >= scrollHeight - 1) {
            setActiveSection(sections[sections.length - 1].id);
            return;
        } else {
            for(var i = itemRefs.current.length - 1; i >= 0; i--){
                var ref = itemRefs.current[i];
                if (ref) {
                    var rect = ref.getBoundingClientRect();
                    // Eğer öğenin üst kısmı container'ın üst kısmından daha yukarıdaysa, o öğeyi aktif yap
                    if (rect.top < contentTop + 200) {
                        setActiveSection(sections[i].id);
                        return;
                    }
                }
            }
        }
        // Eğer hiçbir şey eşleşmezse, ilk öğeyi aktif yap
        setActiveSection(sections[0].id);
    };
    (0,react.useEffect)(function() {
        var container = contentRef.current;
        if (container) {
            container.addEventListener("scroll", handleScroll);
            handleScroll(); // İlk yüklemede çalıştır
            return function() {
                return container.removeEventListener("scroll", handleScroll);
            };
        }
    }, [
        sections
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "bg-buttonBg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "container px-4 py-5 mx-auto lg:py-10 ",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: "relative z-10 text-3xl font-bold text-center lg:text-4xl text-titleColor text-after-shadow-cloud3",
                    children: t("cloudServer:highEfficiencyBestCloud")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "pt-8 text-textGray",
                    dangerouslySetInnerHTML: {
                        __html: t("cloudServer:highEfficiencyBestCloudDesc")
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "grid grid-cols-2 gap-5 lg:gap-10",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "hidden col-span-2 lg:col-span-1 lg:block",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex flex-col items-center justify-center mb-4",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: "/cloudServerSolutions.png",
                                        width: 557,
                                        height: 216,
                                        alt: t("cloudServer:highEfficiencyBestCloud"),
                                        title: t("cloudServer:highEfficiencyBestCloud")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                    className: "space-y-5",
                                    children: sections.map(function(section, index) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                            onClick: function() {
                                                return section.id != activeSection && handleClick(section.id);
                                            },
                                            className: "cursor-pointer text-lg font-semibold ".concat(activeSection === section.id ? "lg:text-black " : "lg:text-textGray"),
                                            children: [
                                                "• ",
                                                section.title
                                            ]
                                        }, index);
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "lg:mt-24 lg:h-[488px] lg:overflow-y-auto customScroll space-y-8 lg:space-y-16 col-span-2 lg:col-span-1",
                            ref: contentRef,
                            children: sections.map(function(section, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    id: section.id,
                                    ref: function(el) {
                                        return itemRefs.current[index] = el;
                                    },
                                    className: "".concat(activeSection == section.id ? "" : "lg:opacity-25", "  ").concat(sections.length == index + 1 ? "lg:pb-32" : "", " pt-4 lg:pt-0"),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                            className: "text-titleColor text-3xl px-1 font-semibold  ".concat(activeSection === section.id ? "relative z-10 lg:text-after-shadow-cloud4" : ""),
                                            children: section.title
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "flex items-center space-x-2",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "mt-4 text-textGray",
                                                dangerouslySetInnerHTML: {
                                                    __html: section.desc
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            className: "mt-4 text-textGray",
                                            children: [
                                                "⚡ ",
                                                section.desc2
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex items-center space-x-2",
                                            children: [
                                                "⚡ ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "mt-4 text-textGray",
                                                    dangerouslySetInnerHTML: {
                                                        __html: section.desc3
                                                    }
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "mt-4 text-textGray",
                                            children: section.desc4 ? "⚡" + section.desc4 : ""
                                        })
                                    ]
                                }, section.id);
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var CloudServers_HighEfficiencyBestCloud = (HighEfficiencyBestCloud);

// EXTERNAL MODULE: ./components/CloudServers/MaxPerformanceWebSiteCloudServer.js
var MaxPerformanceWebSiteCloudServer = __webpack_require__(8421);
;// CONCATENATED MODULE: ./pages/servers/cloud-servers.js
























function cloudServer(param) {
    var datas = param.datas, rates = param.rates;
    var ref, ref1, ref2, ref3;
    var t = (0,esm/* useTranslation */.$G)([
        "common",
        "cloudServer"
    ]).t;
    var router = (0,next_router.useRouter)();
    var ref4 = (0,react.useState)(), servers = ref4[0], setServers = ref4[1];
    var ref5 = (0,_sliced_to_array/* default */.Z)((0,GlobalStore/* useGlobalStore */.s)(function(state) {
        return [
            state.setCurrencyRates,
            state.currencyRates,
            state.currencyType
        ];
    }), 3), setCurrencyRates = ref5[0], currencyRates = ref5[1], currencyType = ref5[2];
    var ref6 = (0,_sliced_to_array/* default */.Z)((0,ConfigurationStore/* useConfigurationStore */.w)(function(state) {
        return [
            state.setDefaultPaymentCycle,
            state.setSelectedServer,
            state.clearAllConfigurations,
            state.setConfigurationType
        ];
    }), 4), setDefaultPaymentCycle = ref6[0], setSelectedServer = ref6[1], clearAllConfigurations = ref6[2], setConfigurationType = ref6[3];
    var ref7 = (0,react.useState)([
        "0",
        "0"
    ]), cloudPrice = ref7[0], setCloudPrice = ref7[1];
    var onGetDedicatedServers = function() {
        var ref;
        var sortedData = datas.sort(function(a, b) {
            return a.order - b.order;
        });
        setServers(sortedData);
        calculatePrice((ref = sortedData[0]) === null || ref === void 0 ? void 0 : ref.one_month_price);
    };
    var calculatePrice = function(p) {
        var ref, ref1, ref2, ref3, ref4, ref5;
        var newPrice = (0,helpersFunc/* changeCurrency */.sy)(currencyRates, currencyType, parseFloat(p === null || p === void 0 ? void 0 : p.toFixed(2)));
        var price = newPrice;
        var splitedPrice = price.split(".");
        setDefaultPaymentCycle(1);
        if (((ref = datas[0]) === null || ref === void 0 ? void 0 : ref.one_month_price) > 0) {
            setDefaultPaymentCycle(1);
        } else if (((ref1 = datas[0]) === null || ref1 === void 0 ? void 0 : ref1.three_month_price) > 0) {
            setDefaultPaymentCycle(3);
        } else if (((ref2 = datas[0]) === null || ref2 === void 0 ? void 0 : ref2.six_month_price) > 0) {
            setDefaultPaymentCycle(6);
        } else if (((ref3 = datas[0]) === null || ref3 === void 0 ? void 0 : ref3.one_year_price) > 0) {
            setDefaultPaymentCycle(12);
        } else if (((ref4 = datas[0]) === null || ref4 === void 0 ? void 0 : ref4.two_year_price) > 0) {
            setDefaultPaymentCycle(24);
        } else if (((ref5 = datas[0]) === null || ref5 === void 0 ? void 0 : ref5.three_year_price) > 0) {
            setDefaultPaymentCycle(36);
        }
        setCloudPrice(splitedPrice);
    };
    var setId = function(id) {
        clearAllConfigurations();
        setConfigurationType("server");
        setSelectedServer(id);
    };
    (0,react.useEffect)(function() {
        onGetDedicatedServers();
    }, []);
    (0,react.useEffect)(function() {
        setCurrencyRates(rates);
    }, [
        rates
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: t("cloudMetaTitle")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: t("cloudMetaDescription")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: t("cloudMetaTitle")
                    }, "title"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:description",
                        content: t("cloudMetaDescription")
                    }, "description")
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "w-full bg-no-repeat transform-gpu bg-cloudServerBg",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "container px-4 py-20 mx-auto lg:px-0",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex justify-between mb-14",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex-1",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "text-xl",
                                                children: t("cloudServer:title")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                className: "my-3 text-5xl font-semibold",
                                                children: t("cloudServer:title2")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                dangerouslySetInnerHTML: {
                                                    __html: t("cloudServer:description")
                                                }
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "justify-end flex-1 hidden lg:flex",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: "/cloudImage.svg",
                                            alt: "cloud",
                                            title: "cloud",
                                            width: "300",
                                            height: "79",
                                            priority: true,
                                            loading: "eager",
                                            className: "transform-gpu"
                                        })
                                    })
                                ]
                            }),
                            servers ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "grid grid-cols-2 gap-8",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "col-span-2 p-5 bg-white rounded-md shadow-md lg:col-span-1",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "text-3xl font-semibold",
                                                children: servers[0].product_name
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "grid grid-cols-3 gap-6 mt-6 lg:w-[400px]",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "col-span-1",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: "text-sm text-textGray",
                                                                children: "CPU"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: "text-2xl font-semibold",
                                                                children: (ref = servers[0].cpu) === null || ref === void 0 ? void 0 : ref.replace("GHz", "vCPU")
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "col-span-1",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: "text-sm text-textGray",
                                                                children: "RAM"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: "text-2xl font-semibold",
                                                                children: servers[0].ram
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "col-span-1",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: "text-sm text-textGray",
                                                                children: "Disk"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: "text-2xl font-semibold",
                                                                children: servers[0].disk.disk_size + " " + servers[0].disk.disk_unit
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "col-span-1",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: "text-sm text-textGray",
                                                                children: t("bandwidth")
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: "text-2xl font-semibold",
                                                                children: servers[0].network
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "col-span-1",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: "text-sm text-textGray",
                                                                children: t("traffic")
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: "text-2xl font-semibold",
                                                                children: servers[0].bandwidth
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "col-span-1",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: "text-sm text-textGray",
                                                                children: "IP"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: "text-2xl font-semibold",
                                                                children: ((ref1 = servers[0]) === null || ref1 === void 0 ? void 0 : ref1.ip_address) === "/32" ? "1 " + t("unit") : (ref2 = servers[0]) === null || ref2 === void 0 ? void 0 : ref2.ip_address
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex items-center justify-between p-3 mt-3 rounded-md bg-[#F1F5F9]",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "flex items-center",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "flex",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                        className: "text-3xl font-semibold text-titleColor",
                                                                        children: [
                                                                            cloudPrice[0],
                                                                            "."
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "flex flex-col ml-1",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                                className: "p-0 m-0 text-sm font-semibold text-titleColor",
                                                                                children: [
                                                                                    cloudPrice[1],
                                                                                    " ",
                                                                                    currencyType
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                                className: "p-0 m-0 text-xs text-titleColor",
                                                                                children: [
                                                                                    t("common:monthly"),
                                                                                    " + ",
                                                                                    t("extra")
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: "ml-4",
                                                                children: t("startingPrice")
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        href: "/configuration",
                                                        as: t("nav:configuration"),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                            onClick: function() {
                                                                var ref;
                                                                (0,googleEvents/* googleEventConfiguration */.Cg)(servers[0], servers[0].one_month_price, servers[0].currency, "product_page");
                                                                setId((ref = servers[0]) === null || ref === void 0 ? void 0 : ref.id);
                                                            },
                                                            name: (ref3 = servers[0]) === null || ref3 === void 0 ? void 0 : ref3.id,
                                                            buttonText: t("common:configure"),
                                                            buttonLeftIcon: "ri-tools-fill"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "grid col-span-2 p-5 bg-white rounded-md shadow-md lg:grid-cols-5 lg:col-span-1",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex flex-col justify-center lg:col-span-3",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "text-2xl font-semibold text-makdosTitleDiv",
                                                        children: t("cloudServer:boxHeading")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "mt-3 text-cardText",
                                                        children: t("cloudServer:boxParagraph")
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "lg:col-span-2",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    src: "/cloudbox.svg",
                                                    alt: "cloud",
                                                    title: "Cloud",
                                                    width: "321",
                                                    height: "320"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex justify-center w-full py-20",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                    type: "Oval",
                                    color: "#FFDD00",
                                    height: 50,
                                    width: 50,
                                    timeout: 3000
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CloudServers_WhatIsCloudServer, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CloudServers_CloudServersAdvantages, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CloudServers_CloudRentalInstallationProcess, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CloudServers_ImportanceOfCloudTech, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CloudServers_HighEfficiencyBestCloud, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MaxPerformanceWebSiteCloudServer/* default */.Z, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-20",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SSS/* default */.Z, {
                    data: router.locale === "tr" ? sss_tr_bulut_sunucu_namespaceObject : sss_en_bulut_sunucu_namespaceObject
                })
            })
        ]
    });
}
var __N_SSP = true;
/* harmony default export */ var cloud_servers = (cloudServer);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2658,4967,1804,8421,9774,2888,179], function() { return __webpack_exec__(68049); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);